import React from "react";
import { Col } from "reactstrap";
import Solicitud from "./Solicitud";
import Comentarios from "./Comentarios";
import ProgresoSolicitud from "../../../Components/Solicitudes/ProgresoSolicitud";

const TicketDetails = ({ solicitud }) => {
  return (
    <React.Fragment>
      <Col xxl={3}>
        {/* Orden: 
          1. Efectividad de la Entrega (dentro de Solicitud, al inicio)
          2. Progreso de Solicitud
          3. Comentarios
          4. Entrega de Medicamentos (dentro de Solicitud)
          5. Información de la Solicitud (dentro de Solicitud)
        */}
        <Solicitud solicitud={solicitud} renderOnlyRest={true} />
        <Solicitud solicitud={solicitud} renderOnlyEfectividad={true} />
        <ProgresoSolicitud solicitud={solicitud} />
        <Comentarios solicitud={solicitud} />
        
      </Col>
    </React.Fragment>
  );
};

export default TicketDetails;
